import {
    AUTHENTICATE_SALESFORCE_REQUEST, AUTHTENTICATING_SALESFORCE_SUCCEEDED, AUTHTENTICATING_SALESFORCE_FAILED,
    UPDATE_SALESFORCE_REQUEST, UPDATING_SALESFORCE_SUCCEEDED, UPDATING_SALESFORCE_FAILED
  } from 'constants/actionTypes';
  
  import axios from 'axios';
  import { createAction } from 'redux-actions';
  import buildUrl from 'build-url';
  import { call, put, takeEvery } from 'redux-saga/effects';
  
  const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
  const SALESFORCE_BASE_URL = `${apiUrl}/integrations/salesforce`;
  
  /*
  * Authenticate Salesforce
  */
  export const authenticateSalesforce = createAction(AUTHENTICATE_SALESFORCE_REQUEST, (code, callback) => {
    return {
      code: code,
      callback: callback
    }
  })
  
  const authenticateSalesforceSucceeded = createAction(AUTHTENTICATING_SALESFORCE_SUCCEEDED, (response) => {
    return response;
  })
  
  const authenticateSalesforceFailed = createAction(AUTHTENTICATING_SALESFORCE_FAILED, (error) => {
    return error;
  })
  
  function* authenticateSalesforceSaga(action) {
    const { code, callback } = action.payload;
  
    let params = {
      code: code
    }
  
    let url = buildUrl(SALESFORCE_BASE_URL, {
      queryParams: params
    });
  
    const authenticateSalesforceAPI = () => {
      return axios.post(url).then(response => response.data);
    }
  
    try {
      const response = yield call(authenticateSalesforceAPI);
      if (response) {
        yield put(authenticateSalesforceSucceeded(response));
      }
      if (callback) {
        callback(response);
      }
    } catch (error) {
      yield put(authenticateSalesforceFailed(error));
    }
  }
  
  /*
  * Update Salesforce
  */
  export const updateSalesforce = createAction(UPDATE_SALESFORCE_REQUEST, (request, callback) => {
    return {
      request: request,
      callback: callback
    };
  })
  
  export const updatingSalesforceSucceeded = createAction(UPDATING_SALESFORCE_SUCCEEDED, (response) => {
    return response;
  })
  
  export const updatingSalesforceFailed = createAction(UPDATING_SALESFORCE_FAILED, (error) => {
    return error;
  })
  
  function* updateSalesforceSaga(action) {
    const { request, callback } = action.payload;
  
    const updateSalesforceAPI = () => {
      return axios.put(SALESFORCE_BASE_URL, request).then(response => response.data);
    }
  
    try {
      const response = yield call(updateSalesforceAPI);
      if (response) {
        yield put(updatingSalesforceSucceeded(response));
      }
      if (callback) {
        callback(response);
      }
    } catch (error) {
      yield put(updatingSalesforceFailed(error));
    }
  }
  
  export default function* salesforceSaga() {
    yield takeEvery(AUTHENTICATE_SALESFORCE_REQUEST, authenticateSalesforceSaga);
    yield takeEvery(UPDATE_SALESFORCE_REQUEST, updateSalesforceSaga);
  }
